export const toggleVisibility = () => {
  const buttons = document.querySelectorAll("[data-wm-toggle-button]");

  if (buttons.length === 0) {
    return;
  }

  const toggleElements = (button, content) => {
    button.classList.toggle("content-visible");
    content.classList.toggle("content-visible");
  };

  [...buttons].forEach((button) => {
    const id = button.dataset.wmToggleButton;

    const content = document.querySelector(`[data-wm-toggle-content="${id}"]`);

    button.addEventListener(
      "click",
      function () {
        toggleElements(button, content);
      },
      false
    );
  });
};
